module.exports = __webpack_public_path__ + "static/media/odaLogoBlack.c0181dec.png";